/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-04-29 13:28:47
 * @LastEditors: luckymiaow
 */

import { nextTick, ref } from 'vue';

export default () => {
  const style = ref<Record<string, any>>({});

  let divPosition = {
    x: 0,
    y: 0,
  };

  const moveModalDown = e => {
    divPosition.x = e.offsetX;
    divPosition.y = e.offsetY;
    document.addEventListener('mousemove', moveModal);
  };

  const moveModal = e => {
    e.preventDefault();
    let left = e.clientX - divPosition.x;
    let top = e.clientY - divPosition.y;
    style.value.top = `${top}px`;
    style.value.left = `${left}px`;
    style.value.margin = 0;
  };

  const addMove = async moveRef => {
    document.onmouseup = function () {
      document.removeEventListener('mousemove', moveModal);
    };
    await nextTick();
    moveRef.parentNode.parentNode.addEventListener('mousedown', moveModalDown);
  };

  return { addMove, style };
};
